export default __webpack_public_path__ + "10955336c053efe66ea7d0af6bff7a56.png";